import { CandidateServicePath } from "utils/constants";
import { buildQueryString } from "utils/helpers";

export const candidateRequests = {
  // Campaign exam
  importCampaignExamResults: campaignExamId => `${CandidateServicePath}campaign-exams/${campaignExamId}/results/import`,
  getCampaignExamResultsProtocol: campaignExamId =>
    `${CandidateServicePath}campaign-exams/${campaignExamId}/results/protocol`,
  getCampaignExamProtocol: campaignExamId => `${CandidateServicePath}campaign-exams/${campaignExamId}/protocol`,
  exportCampaignExamResults: campaignExamId => `${CandidateServicePath}campaign-exams/${campaignExamId}/results/export`,
  getCampaignExamResultsTemplate: () => `${CandidateServicePath}campaign-exams/results/template`,
  approveCampaignExamResults: campaignExamId =>
    `${CandidateServicePath}campaign-exams/${campaignExamId}/results/approve`,

  // Exam rooms
  campaignExamRoom: (campaignExamId, roomId) =>
    `${CandidateServicePath}campaign-exams/${campaignExamId}/rooms/${roomId}`,
  updateCampaignExamRoomsPriority: campaignExamId =>
    `${CandidateServicePath}campaign-exams/${campaignExamId}/rooms/update-priority`,

  // Campaigns by sub-type
  campaignByType: type => `${CandidateServicePath}campaigns/${type}`,
  finalizeCampaign: id => `${CandidateServicePath}campaigns/${id}/finalize`,

  // POST generates the Google accounts, GET reads back the ones already generated.
  campaignGoogleUsers: campaignId => `${CandidateServicePath}campaigns/${campaignId}/google-users`,

  // Campaign rankings
  createCampaignRanking: campaignId => `${CandidateServicePath}campaigns/${campaignId}/ranking`,
  campaignRanking: id => `${CandidateServicePath}campaigns/ranking/${id}`,
  generateCampaignRankingDraft: id => `${CandidateServicePath}campaigns/ranking/${id}/generate-draft`,
  approveCampaignRanking: id => `${CandidateServicePath}campaigns/ranking/${id}/approve`,
  exportCampaignRanking: id => `${CandidateServicePath}campaigns/ranking/${id}/export`,
  getCampaignRankingSummary: (campaignRankingId, specialityId) =>
    `${CandidateServicePath}campaigns/ranking/${campaignRankingId}/summary/${specialityId}`,
  previewCampaignRankingAdditionalCapacity: id =>
    `${CandidateServicePath}campaigns/ranking/${id}/additional-capacity/preview`,
  addCampaignRankingAdditionalCapacity: id => `${CandidateServicePath}campaigns/ranking/${id}/additional-capacity`,

  // Candidacies
  updateCandidacyInfo: id => `${CandidateServicePath}candidacies/${id}/info`,
  updateCandidacyStatus: id => `${CandidateServicePath}candidacies/${id}/status`,
  updateCandidacyPreparatoryClass: id => `${CandidateServicePath}candidacies/${id}/preparatory-class`,
  updateCandidacyNote: id => `${CandidateServicePath}candidacies/${id}/note`,
  returnCandidacyForCorrection: id => `${CandidateServicePath}candidacies/${id}/correction`,
  addCandidacyIntermediary: id => `${CandidateServicePath}candidacies/${id}/intermediaries`,
  updateCandidacyAdmissionAfterEducation: id =>
    `${CandidateServicePath}candidacies/${id}/admission-after-education-levels`,
  transferCandidacyPayment: () => `${CandidateServicePath}candidacies/transfer-payment`,
  searchCandidacy: () => `${CandidateServicePath}candidacies/search`,
  getCandidacyDynamicDeclaration: (id, declarationId) =>
    `${CandidateServicePath}candidacies/${id}/dynamic-declarations/${declarationId}`,
  updateCandidacyPaidEducation: id => `${CandidateServicePath}candidacies/${id}/paid-education`,
  getCandidacyExamProtocol: (candidacyId, campaignExamId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/exams/${campaignExamId}/protocol`,
  updateCandidacySpecialityReinstates: id => `${CandidateServicePath}candidacies/${id}/specialities/reinstates`,
  updateCandidacyPreferenceAdditionalData: (id, preferenceId) =>
    `${CandidateServicePath}candidacies/${id}/preferences/${preferenceId}/additional-data`,
  // Candidacies — specialities & grades
  getCandidacyManualPickScoreComponentForUpdate: id =>
    `${CandidateServicePath}candidacies/${id}/manual-pick-score-component/for-update`,
  updateCandidacyManualPickScoreComponent: id => `${CandidateServicePath}candidacies/${id}/manual-pick-score-component`,
  candidacySpeciality: (candidacyId, specialityId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/specialities/${specialityId}`,
  // Student status & transfer (paid -> state order)
  candidacySpecialityStudentStatus: (candidacyId, specialityId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/specialities/${specialityId}/students/status`,
  transferStudentToStateOrder: (candidacyId, specialityId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/specialities/${specialityId}/students/transfer-to-state-order`,
  changeCandidacyExamSlot: (candidacyId, campaignExamId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/exams/${campaignExamId}/change-slot`,
  candidacyExamGrades: (candidacyId, campaignExamId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/exams/${campaignExamId}/grades`,
  getCandidacyInstructionLanguagesForUpdate: id =>
    `${CandidateServicePath}candidacies/${id}/instruction-languages/for-update`,
  updateCandidacyInstructionLanguages: id => `${CandidateServicePath}candidacies/${id}/instruction-languages`,
  getCandidacySpecialitiesForAdd: id => `${CandidateServicePath}candidacies/${id}/specialities/for-add`,
  getCandidacySpecialityManualPickComponents: (candidacyId, specialityId) =>
    `${CandidateServicePath}candidacies/${candidacyId}/specialities/${specialityId}/manual-pick-components`,
  addCandidacySpeciality: id => `${CandidateServicePath}candidacies/${id}/specialities`,
  updateCandidacySpecialityPriorities: id => `${CandidateServicePath}candidacies/${id}/specialities/priorities`,

  getSchoolSubjectsByCandidacy: candidacyId => `${CandidateServicePath}school-subjects/candidacies/${candidacyId}`,
  getCandidacySchoolSubjectGrades: candidacyId =>
    `${CandidateServicePath}school-subjects/candidacies/${candidacyId}/grades`,
  userSchoolSubjectGrades: userId => `${CandidateServicePath}school-subjects/users/${userId}/grades`,

  // Candidate enrollments
  getCandidateEnrollments: ({ candidacyId, specialityId }) =>
    `${CandidateServicePath}candidate-enrollments?CandidacyId=${candidacyId}&SpecialityId=${specialityId}`,

  specialityScoreFormulas: specialityId => `${CandidateServicePath}specialities/${specialityId}/score-formulas`,

  receivePaymentExpectation: () => `${CandidateServicePath}payment-expectations/receive`,

  // Preparatory years
  preparatoryYears: () => `${CandidateServicePath}preparatory-years`,
  preparatoryYearCandidates: () => `${CandidateServicePath}preparatory-years/candidates`,
  getPreparatoryYearCandidateEnroll: candidacyId =>
    `${CandidateServicePath}preparatory-years/candidates/${candidacyId}/enroll`,
  enrollPreparatoryYearCandidate: () => `${CandidateServicePath}preparatory-years/candidates/enroll`,

  getCampaignCitizenship: campaignIds => `${CandidateServicePath}campaigns/${campaignIds}/citizenship`,
  getPreliminaryCampaignsSelect: subType =>
    `${CandidateServicePath}campaigns/preliminary/select${subType !== undefined ? `?SubType=${subType}` : ""}`,
  getLastApprovedCampaignRanking: ({ campaignId, specialityId, currentPage = 1, perPage = 10 } = {}) =>
    `${CandidateServicePath}campaigns/ranking/last/approved${buildQueryString({
      CurrentPage: currentPage,
      PerPage: perPage,
      campaignId,
      specialityId,
    })}`,

  getUserCandidacies: userId => `${CandidateServicePath}users/${userId}/candidacies`,

  candidaciesBySubType: subTypePath => `${CandidateServicePath}${subTypePath}`,

  //Selects
  getCampaignTypesSelect: () => `${CandidateServicePath}campaign-types`,
  getSchoolSubjectsSelect: () => `${CandidateServicePath}school-subjects/all`,
  getScoreComponentsSelect: () => `${CandidateServicePath}specialities/0/score-formulas/components/select`,
  getSchoolSubjectsSpecialitiesSelect: () => `${CandidateServicePath}school-subjects/specialities`,
  getCampaignAvailabilitySelect: () => `${CandidateServicePath}campaigns/availability`,
  getCampaignsSelect: () => `${CandidateServicePath}campaigns/select`,
  getCampaignChildrenSelect: () => `${CandidateServicePath}campaigns/children`,
  getCampaignExamsSelect: () => `${CandidateServicePath}campaign-exams/select`,
  getExamSlotsSelect: () => `${CandidateServicePath}exam-slots/select`,
  getCampaignSpecialitiesSelect: campaignId => `${CandidateServicePath}campaigns/${campaignId}/specialities`,
  getCandidacieStatesSelect: () => `${CandidateServicePath}candidacies/states`,
  getSpecialityScoreFormulasManualSelectionSelect: (id, { citizenshipId, specialityId } = {}) =>
    `${CandidateServicePath}specialities/${id}/score-formulas/manual-selections${buildQueryString({
      CitizenshipId: citizenshipId,
      SpecialityId: specialityId,
    })}`,
};
